import { ReactNode } from 'react';

import styles from '@components/typography/Typography.module.css';

type Color = 'primary700' | 'neutral500' | 'shadesWhite' | 'neutral300';

type Props = {
  children: ReactNode;
  className?: string;
  color?: Color;
};

const Heading1 = ({ children, className, color = 'primary700', ...otherStuff }: Props) => (
  <h1 className={`${className ?? ''} ${styles[color]}  ${styles.heading1}`} {...otherStuff}>
    {children}
  </h1>
);

export default Heading1;
